var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.03 81.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.12,78.47a4.86,4.86,0,0,1-2,2.42,4.51,4.51,0,0,1-2.89.65,4.58,4.58,0,0,1-4.14-3.07L29.22,41.2l2.36.35L18.1,78.47A4.41,4.41,0,0,1,14,81.54,4.77,4.77,0,0,1,11,80.89a5.15,5.15,0,0,1-2-2.42L.35,54.82A5.49,5.49,0,0,1,0,52.93,4.87,4.87,0,0,1,1.3,49.5a4.57,4.57,0,0,1,3.55-1.42,5,5,0,0,1,2.6.7,3.89,3.89,0,0,1,1.66,2.37l6.15,17.74-2.49-.12L26.5,33.27a4.55,4.55,0,0,1,4.49-3,4.27,4.27,0,0,1,2.66.77,4.41,4.41,0,0,1,1.48,2.19l14.44,35.5-3,.23L69.79,3.08C70.48,1,71.92,0,74.29,0a4.53,4.53,0,0,1,3.25,1.3A4.18,4.18,0,0,1,79,4.86a3.41,3.41,0,0,1-.18,1M37.57,17.77a6.43,6.43,0,1,1-6.43-6.43A6.43,6.43,0,0,1,37.57,17.77Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo_3.5b5d08afc2632098797953f2aaf70eb1.svg";
export { ForwardRef as ReactComponent };